import * as React from "react";
import { Box, Stack, TextField } from "@mui/material";
import CclDrawer from "../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../components/common/cclButtons/cclButton";
import CclLoadingButton from "../../../components/common/cclButtons/cclLoadingButton";

export interface AddTrainerDrawerProps {
    open: boolean;
    onClose: () => void;
}

const AddTrainerDrawer: React.FC<AddTrainerDrawerProps> = (props) => {
    const handleSave = () => {};

    return (
        <CclDrawer title="Add Trainer" open={props.open} onClose={props.onClose}>
            <Box>
                <Stack spacing={3}>
                    <TextField id="trainer-name" label="Name" variant="standard" />
                    <TextField id="trainer-email" label="Email" variant="standard" />
                </Stack>
            </Box>
            <CclDrawerActionBar>
                <CclLoadingButton onClick={handleSave} mode={"primary"} loading={false}>
                    Save
                </CclLoadingButton>
                <CclButton onClick={props.onClose} mode={"secondary"}>
                    Cancel
                </CclButton>
            </CclDrawerActionBar>
        </CclDrawer>
    );
};

export default AddTrainerDrawer;